/**
 * toString :: * -> String
 *
 * @param {*} x
 * @return {string}
 */
export function toString(x) {
  return x.toString();
}
